import { FC } from "react"
import { SchedulesClone } from "../../../module/schedules/containers/clone"

export const SchedulesClonePage: FC = () => <SchedulesClone />
